<template>
    <div>
        <div v-if="isVisible" class="input-box">
            <VuePhoneNumberInput
                v-model="defaultNumber"
                :no-validator-state="true"
                :default-country-code="defaultCode"
                @update="onUpdate"
                :translations="{phoneNumberLabel: 'Telefone'}"
                :disabled="disabledphone"
                :noCountrySelector="displayCountry"
                @phone-number-focused="disableEmailField()"
                @phone-number-blur="enableEmailField()"
            />
        </div>
    </div>
</template>

<script>
    import debounce from 'lodash.debounce';
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';

    export default {
        components: { VuePhoneNumberInput },
        props: {
            isForm: {
                required: false,
            },
            defaultCountryCode: {
                required: false,
                default: 'PT',
            },
            defaultPhoneNumber: {
                required: false,
            },
            disabledphone: {
                required: false,
            },
        },

        data() {
            return {
                defaultNumber: "",
                defaultCode: 'PT',
                displayCountry: false,
                isVisible: true
            }
        },

        mounted() {
            if(this.defaultPhoneNumber) {
                this.defaultNumber = this.defaultPhoneNumber
                this.updateField({phoneNumber: this.defaultPhoneNumber})
            }
            if(this.defaultCountryCode) {
                this.defaultCode = this.defaultCountryCode
            }
            this.$root.$on('reset-phone-field', () => {
                this.cleanUp()
            })
        },

        methods: {
            updateField(payload) {
                this.disableEmailField();
                if(this.isForm){
                    this.$emit('input', payload);
                    if(!payload.phoneNumber){
                        this.$emit('clearField', null);
                    }
                } else {
                    if(payload.countryCode && payload.countryCallingCode && payload.nationalNumber){
                        this.livewirePhone([payload.countryCode, payload.countryCallingCode, payload.nationalNumber])
                    }
                }
            },
            onUpdate(payload) {
                this.updateField(payload)
            },
            livewirePhone: debounce(function (params) {
                //when updatePhoneInfo is triggered, b/e cleans updateEmailInfo
                Livewire.emit('updatePhoneInfo', params);
            }, 400),
            disableEmailField(){
                document.getElementById("recover-password-email").classList.add('disabled');
                document.getElementById("recover-password-email").disabled = true;
            },
            enableEmailField(){
                if(this.defaultNumber == "" || this.defaultNumber == null ){
                    document.getElementById("recover-password-email").classList.remove('disabled');
                    document.getElementById("recover-password-email").disabled = false;
                }
                else {
                    this.disableEmailField();
                }
            },
            cleanUp(){
                this.defaultNumber = '',
                this.defaultCode = 'PT',
                this.displayCountry = true
                this.displayCountry = false
                this.isVisible = false
                setTimeout(() => this.isVisible = true, 1000);
            }
        }
    }
</script>

<style>

</style>
